/**
 * Sorts an array of items by custom priority labels followed by alphabetical order.
 * The first six items, if present, are sorted according to a predefined set of priority labels.
 * Remaining items, if any, are sorted alphabetically by their 'label' property. An 'underline'
 * separator is inserted between the prioritized and alphabetically sorted items.
 *
 * @param {Array} items - Array of objects with a 'label' property to be sorted.
 * @returns {Array} The sorted array with prioritized items first, followed by an 'underline' and the alphabetically sorted items.
 */
export const sortDataWithManualTopConditions = (items) => {
  const priorityLabels = [
    'Depression',
    'Eating Disorders',
    'Trauma',
    'Anxiety',
    'Bipolar',
    'Alcohol'
  ]

  // Create a mapping of priorities with a default value for non-priority items
  const priorityMap = new Map(
    priorityLabels.map((label, index) => [label, index])
  )
  const defaultPriority = priorityLabels.length // Items not in the priority list will get this index

  // Sort the items based on the defined priority, then alphabetically for the rest
  const sortedItems = items.sort((a, b) => {
    const priorityA = priorityMap.get(a.label) ?? defaultPriority
    const priorityB = priorityMap.get(b.label) ?? defaultPriority
    if (priorityA !== priorityB) {
      return priorityA - priorityB
    }
    return a.label.localeCompare(b.label)
  })

  // Determine the breakpoint index (up to 6 or the length of the array)
  const breakpoint = Math.min(sortedItems.length, 6)
  const topConditions = sortedItems.slice(0, breakpoint)
  const rest =
    breakpoint < sortedItems.length
      ? ['underline', ...sortedItems.slice(breakpoint)]
      : []

  return [...topConditions, ...rest]
}
